<template>
	<div class="header__login">
			<a
				class="header__login-link"
				:class="{
					'is-loggedin': loggedin
				}"
				@click.prevent="onClick"
				v-html="linkText"
			/>
	</div>
</template>

<script>
import { mapGetters } from "vuex"
import htmlComponent from "htmlcomponent"

export default {
	mixins: [],
	components: {},
	data() {
		return {
			overlayType: 'login',
		};
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
		]),
		linkText() {
			return this.isLoggedIn
				? this.$t('login.widget.linkTextLoggedIn')
				: this.$t('login.widget.linkTextLoggedOut');
		},
		loggedin(){
			return this.isLoggedIn
		}
	},
	methods: {
		onClick() {
			if (this.isLoggedIn) {
				htmlComponent.send('overlay:close', {type: this.overlayType});
				this.$store.dispatch('redirect', {name: 'account'})
			} else {
				htmlComponent.send('overlay:toggle', {type: this.overlayType});
			}
		}
	}
}
</script>

<style></style>
